import { useLocation } from 'react-router-dom';

const STRIP: RegExp[] = [
	/^\d+$/, // 123
	/^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i, // uuid
];

const normalize = (s: string) =>
	s
		.trim()
		.toLowerCase()
		.replace(/-/g, '_')
		.replace(/[^a-z0-9_]/g, '');

const isDynamic = (s: string) => STRIP.some((rx) => rx.test(s));

export const usePageKey = () => {
	const location = useLocation();

	const segments = location.pathname.split('/').filter(Boolean);

	const clean = segments
		.filter((s) => !isDynamic(s))
		.map(normalize)
		.filter(Boolean);

	return clean.length ? clean.join('__') : 'home';
};
